import { DateRange } from '../../../shared/components/filter-date-range/filter-date-range.component';

export interface MovementFilters {
  creationDate: DateRange | null;
  updateDate: DateRange | null;

  tipo: string | number | null;
  estado: string | number | null;
  empresa: string | number | null;

  categoria: string | number | null;
  cuentaContable: string | number | null;
  montoMin: number | null;
  montoMax: number | null;

  numeroTransaccion: string;
  numeroComprobante: string;

  incluirBifurcaciones: string | null;
  detalle: string;

  autorizadoPor: string | number | null;
  creadoPor: string | number | null;
}

export interface FilterSelectOption {
  value: string | number;
  label: string;
  categoryId?: number | null;
}

export const INITIAL_FILTERS: MovementFilters = {
  creationDate: null,
  updateDate: null,
  tipo: null,
  estado: null,
  empresa: null,
  categoria: null,
  cuentaContable: null,
  montoMin: null,
  montoMax: null,
  numeroTransaccion: '',
  numeroComprobante: '',
  incluirBifurcaciones: null,
  detalle: '',
  autorizadoPor: null,
  creadoPor: null,
};

export function filtersToQueryParams(
  filters: MovementFilters
): Record<string, string> {
  const params: Record<string, string> = {};

  if (filters.creationDate?.start) {
    params['creation_date_start'] = filters.creationDate.start;
  }
  if (filters.creationDate?.end) {
    params['creation_date_end'] = filters.creationDate.end;
  }
  if (filters.updateDate?.start) {
    params['update_date_start'] = filters.updateDate.start;
  }
  if (filters.updateDate?.end) {
    params['update_date_end'] = filters.updateDate.end;
  }

  if (filters.tipo) {
    params['document_type'] = String(filters.tipo);
  }
  if (filters.estado !== null && filters.estado !== undefined) {
    params['state'] = String(filters.estado);
  }
  if (filters.empresa) {
    params['empresa'] = String(filters.empresa);
  }

  if (filters.categoria) {
    params['categoria'] = String(filters.categoria);
  }
  if (filters.cuentaContable) {
    params['accounting_account'] = String(filters.cuentaContable);
  }
  if (filters.montoMin !== null && filters.montoMin !== undefined) {
    params['monto_min'] = filters.montoMin.toString();
  }
  if (filters.montoMax !== null && filters.montoMax !== undefined) {
    params['monto_max'] = filters.montoMax.toString();
  }

  if (filters.numeroTransaccion) {
    params['transaction_number'] = filters.numeroTransaccion;
  }
  if (filters.numeroComprobante) {
    params['numero_comprobante'] = filters.numeroComprobante;
  }

  if (filters.incluirBifurcaciones) {
    params['incluir_bifurcaciones'] = String(filters.incluirBifurcaciones);
  }
  if (filters.detalle) {
    params['detalle'] = filters.detalle;
  }

  if (filters.creadoPor) {
    params['created_by'] = String(filters.creadoPor);
  }
  if (filters.autorizadoPor) {
    params['authorized_by'] = String(filters.autorizadoPor);
  }

  return params;
}
